import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { ColumnSelectionModule } from '../../../columns/column-selection/column-selection.module';
import { FilterSelectionModule } from '../../../filter/filter-selection/filter-selection.module';
import { MatRowKeyboardSelectionModule } from '../../../../core/directive/mat-row-keyboard-selection.module';
import { ResizeColumnModule } from '../../../../core/directive/resize-column.module';
import { MaterialCatalogListItemComponent } from './material-catalog-list-item.component';

@NgModule({
  declarations: [MaterialCatalogListItemComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    ColumnSelectionModule,
    FilterSelectionModule,
    MatRowKeyboardSelectionModule,
    ResizeColumnModule,
  ],
  exports: [MaterialCatalogListItemComponent],
  providers: [],
})
export class MaterialCatalogListItemModule {}
